import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { MotivoTransicaoService } from '../../../../shared/services/apis/vendas/motivo-transicao.service';
import { MotivoTransicaoRequest } from '../../../../shared/services/requests/vendas/motivo-transicao.request';
import { CreateMotivoTransicaoResponse } from '../../../../shared/services/responses/vendas/create-motivo-transicao.response';
import { HeaderComponent } from '../../../../shared/components/header/header.component';

@Component({
  selector: 'app-motivo-transicao-cadastro',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    LoadingBoxComponent,
    FooterActionComponent,
    HeaderComponent,
  ],
  templateUrl: './motivo-transicao-cadastro.component.html',
  styleUrl: './motivo-transicao-cadastro.component.css',
})
export class MotivoTransicaoCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Vendas;
  public form: FormGroup;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isEdicao: boolean = false;
  public idMotivoTransicao: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private motivoTransicaoService: MotivoTransicaoService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.route.params.subscribe(params => {
      if (params['idMotivoTransicao']) {
        this.idMotivoTransicao = +params['idMotivoTransicao'];
        this.isEdicao = true;
        this.carregarMotivo();
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      nome: ['', Validators.required],
      isAtivo: [true],
    });
  }

  private carregarMotivo(): void {
    this.isLoading = true;
    this.motivoTransicaoService.getById(this.idMotivoTransicao).subscribe({
      next: (res: CreateMotivoTransicaoResponse) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          this.voltar();
          return;
        }
        if (res.motivo) {
          this.form.patchValue({
            nome: res.motivo.nome,
            isAtivo: res.motivo.isAtivo,
          });
        }
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao carregar o motivo.', AlertType.error);
        this.voltar();
      },
    });
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.alertService.show('Aviso', 'Informe o nome do motivo.', AlertType.warning);
      return;
    }

    this.isSaving = true;
    const request: MotivoTransicaoRequest = {
      nome: (this.form.value.nome as string).trim(),
      isAtivo: this.form.value.isAtivo,
    };

    if (this.isEdicao) {
      this.motivoTransicaoService
        .update(this.idMotivoTransicao, request)
        .subscribe({ next: res => this.tratarRetorno(res), error: () => this.tratarErro() });
    } else {
      this.motivoTransicaoService
        .create(request)
        .subscribe({ next: res => this.tratarRetorno(res), error: () => this.tratarErro() });
    }
  }

  private tratarRetorno(res: CreateMotivoTransicaoResponse): void {
    this.isSaving = false;
    if (res.isError) {
      this.alertService.show('Erro', res.errorDescription, AlertType.error);
      return;
    }
    this.alertService.show('Sucesso', 'Motivo salvo com sucesso', AlertType.success);
    this.voltar();
  }

  private tratarErro(): void {
    this.isSaving = false;
    this.alertService.show('Erro', 'Ocorreu um erro ao salvar o motivo.', AlertType.error);
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/vendas/motivos-transicao']);
  }
}
